export const News_EN = {
  news: {
    create_btn: "Create new article",
    desc: "Stay up to date with the latest news from",
    featured: "Featured news",
    headline: {
      default: "News",
      mine: "My articles",
      editorial: "Editorial articles",
      popular: "Most popular",
      community: "Community articles",
    },
    badges: {
      mine: "Mine",
      editorial: "Editorial",
      popular: "Most popular",
      community: "Community created",
    },
    actions: {
      copyUrl: "Copy the URL",
      copied: "Copied link to clipboard",
      copyFailed: "Failed to copy link to clipboard",
    },
  },
};
